'use client'

import { useEffect } from 'react'

// iOS-proof body scroll lock for fullscreen modals.
// Why both <html> AND <body>: globals.css sets html{overflow-x:hidden}, which
// makes <html> the effective scroll container — locking body alone fails on
// iOS Safari and Samsung Internet. position:fixed + saved scrollY is the
// standard pattern used by Notion, Linear, Vercel.
export function useBodyScrollLock(isLocked) {
  useEffect(() => {
    if (!isLocked) return
    const scrollY = window.scrollY
    const html = document.documentElement
    const body = document.body
    html.style.overflow = 'hidden'
    body.style.position = 'fixed'
    body.style.top = `-${scrollY}px`
    body.style.width = '100%'
    body.style.overflow = 'hidden'
    return () => {
      html.style.overflow = ''
      body.style.position = ''
      body.style.top = ''
      body.style.width = ''
      body.style.overflow = ''
      window.scrollTo(0, scrollY)
    }
  }, [isLocked])
}
